import moment from 'moment';
import { isEmpty, isNil } from 'ramda';
import { validateDate } from '../../utils/validations';

const validate = (values: Object, props: Object) => {
  const errors = {};

  const moveTypeMsg = props.moveType === 'moveIn' ? 'Move-In' : 'Move-Out';

  const { editMoveDate } = values;

  /**
   * Required Fields
   */
  if (isNil(editMoveDate) || isEmpty(editMoveDate)) {
    errors['editMoveDate'] = `${moveTypeMsg} Date is required.`;
  }

  /**
   * Valid Dates
   */
  if (!errors['editMoveDate'] && !validateDate(editMoveDate)) {
    errors[
      'editMoveDate'
    ] = `${moveTypeMsg} Date must be a valid date format (MM/DD/YYYY).`;
  }

  /**
   * Not in the future (Move-In and Move-Out corrections, behind household-mi-mo-date-changes). The
   * picker disables future days, but the field is still typeable, so reject a future date here too
   * rather than let it reach the server (or, for a Move-In, trip the unrelated fiscal-period rule).
   */
  if (
    !errors['editMoveDate'] &&
    props.isHouseholdMiMoDateChangesEnabled &&
    moment(editMoveDate).isAfter(moment(), 'day')
  ) {
    errors['editMoveDate'] = `${moveTypeMsg} Date cannot be in the future.`;
  }

  if (props.additionalValidation) {
    const errMsg = props.additionalValidation(editMoveDate);
    if (errMsg) {
      errors['editMoveDate'] = errMsg;
    }
  }

  return errors;
};

export default validate;
